<template>
  <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke="currentColor" d="M12 10V1L1 14H10V23L21 10H12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>
</template>